import React from "react";

const OperAiChat = () => {
  return <div>OperAiChat</div>;
};

export default OperAiChat;
